import { ROLE_LABELS, ROLE_STYLES, assignableRoles } from "@/lib/permissions";
import { useAuth } from "@/context/AuthContext";

export const STATUS_STYLES = {
  approved: "bg-emerald-100 text-emerald-800",
  pending: "bg-amber-100 text-amber-800",
  rejected: "bg-red-100 text-red-800",
  suspended: "bg-zinc-200 text-zinc-700",
  accepted: "bg-emerald-100 text-emerald-800",
  expired: "bg-zinc-200 text-zinc-700",
  revoked: "bg-red-100 text-red-800",
};

export const STATUS_LABELS = { approved: "Active", pending: "Pending", rejected: "Rejected", suspended: "Suspended", accepted: "Accepted", expired: "Expired", revoked: "Revoked" };

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");

export function Avatar({ u }) {
  if (u.picture) return <img src={u.picture} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" referrerPolicy="no-referrer" />;
  return (
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold text-sm font-bold text-primary">
      {(u.name || u.email || "?").charAt(0).toUpperCase()}
    </span>
  );
}

export function RoleBadge({ role }) {
  return <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${ROLE_STYLES[role] || "bg-secondary"}`}>{ROLE_LABELS[role] || role}</span>;
}

export function StatusBadge({ status, testId }) {
  return <span data-testid={testId} className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${STATUS_STYLES[status] || "bg-secondary"}`}>{STATUS_LABELS[status] || status}</span>;
}

export function RoleSelect({ value, onChange, testId, disabled }) {
  const { user } = useAuth();
  return (
    <select
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className="rounded-xl border border-border bg-background px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-gold/40 disabled:opacity-60"
    >
      {assignableRoles(user).map((r) => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
    </select>
  );
}

export function Empty({ children }) {
  return <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">{children}</div>;
}
